import { InfoIcon } from '@music-vine/cadence/icons';
import Tooltip from '@/components/Tooltip';
import { cn } from '@/lib/utils';
import { PRICING_PAGE_TOOLTIP_DELAY } from '../constants';
import type { FeatureCategory } from './types';
const TextWithTooltip = ({
  text,
  tooltipLabel,
  className
}: {
  text: string;
  tooltipLabel: string;
  className?: string;
}) => <div className={cn('relative mx-auto w-fit', className)} data-sentry-component="TextWithTooltip" data-sentry-source-file="data.tsx">
    <span className="inline-block">
      <span>{text}</span>
      <Tooltip delayDuration={PRICING_PAGE_TOOLTIP_DELAY} label={tooltipLabel} showOnClick data-sentry-element="Tooltip" data-sentry-source-file="data.tsx">
        <span className="mx-1 inline align-text-bottom">
          <InfoIcon className="h-4 w-4 shrink-0" data-sentry-element="InfoIcon" data-sentry-source-file="data.tsx" />
          <span className="sr-only">More info</span>
        </span>
      </Tooltip>
    </span>
  </div>;

/**
 * Feature data per the 2026 plan update designs: no Free column, a Business
 * column, and the License section recut by audience.
 */
export const featuresData: FeatureCategory[] = [{
  name: 'Unlimited access',
  features: [{
    key: 'music',
    name: 'Music',
    cells: {
      free: 'Limited',
      essentials: true,
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'sound-effects',
    name: 'Sound effects',
    cells: {
      free: 'Limited',
      essentials: true,
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'stock-videos',
    name: 'Stock video',
    cells: {
      free: 'Limited',
      essentials: 'Limited',
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'motion-graphics',
    name: 'Motion graphics',
    cells: {
      free: 'Limited',
      essentials: 'Limited',
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'luts',
    name: 'LUTs',
    cells: {
      free: 'Limited',
      essentials: 'Limited',
      creator: true,
      pro: true,
      business: true
    }
  }]
}, {
  name: 'License',
  features: [{
    key: 'individuals',
    name: 'Individuals',
    cells: {
      free: true,
      essentials: true,
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'freelancers',
    name: 'Freelancers',
    cells: {
      free: false,
      essentials: false,
      creator: false,
      pro: true,
      business: true
    }
  }, {
    key: 'solo-professionals',
    name: 'Solo professionals',
    cells: {
      free: false,
      essentials: false,
      creator: false,
      pro: true,
      business: true
    }
  }, {
    key: 'organizations-and-teams',
    name: 'Organizations and teams',
    cells: {
      free: false,
      essentials: false,
      creator: false,
      pro: false,
      business: true
    }
  }, {
    key: 'digital-ads',
    name: 'Digital ads',
    cells: {
      free: false,
      essentials: false,
      creator: false,
      pro: true,
      business: true
    }
  }, {
    key: 'client-content',
    name: 'Client content',
    cells: {
      free: false,
      essentials: false,
      creator: false,
      pro: true,
      business: true
    }
  }]
}, {
  name: 'Features',
  features: [{
    key: 'playlist-generator',
    name: 'Playlist generator',
    cells: {
      free: true,
      essentials: true,
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'sync-preview',
    name: 'Sync Preview',
    cells: {
      free: true,
      essentials: true,
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'adaptive-music',
    name: 'Customize music duration',
    cells: {
      free: true,
      essentials: true,
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: 'copyright-protection',
    name: 'Copyright protection',
    cells: {
      free: 'With Uppbeat Credit',
      essentials: 'Safelist 1 channel',
      creator: 'Safelist 3 channels',
      pro: 'Safelist 10 channels',
      business: 'Safelist 10 channels'
    }
  }, {
    key: '1080p-sv',
    name: '1080p stock video',
    cells: {
      free: false,
      essentials: false,
      creator: true,
      pro: true,
      business: true
    }
  }, {
    key: '4k-sv',
    name: '4K stock video',
    cells: {
      free: false,
      essentials: false,
      creator: false,
      pro: true,
      business: true
    }
  }]
}];